export function isSupportedBrowser(): boolean {
    if(!window.PointerEvent) return false;
    if(!window.ResizeObserver) return false;
    return true;
}